module.exports = __webpack_public_path__ + "img/sesac-music-group-badge.6305def9.png";